<template>
    <div>
        <page-title-bar title="BẢNG THEO DÕI INTERNET"></page-title-bar>
        <v-container grid-list-xl pt-0>
            <page-tool-bar show_search show_building :chosen_building.sync="chosen_building" :search.sync="search">
                <v-flex xs12 md2>
                    <v-select
                        v-model="filterStatus"
                        :items="statusOptions"
                        label="Lọc theo trạng thái"
                        hide-details
                        prepend-icon="filter_list"
                    ></v-select>
                </v-flex>
                <v-flex shrink>
                    <div class="text-right">
                        <create-internet @reloadTable="reload_table++"></create-internet>
                        <v-btn @click="exportCSV++" color="primary" dark>XUẤT EXCEL</v-btn>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card>
                        <internet-table :exportCSV="exportCSV" :chosen_building="chosen_building" :search="search"
                            :reload_table="reload_table" :filterStatus="filterStatus"></internet-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import InternetTable from './InternetTable';
import CreateInternet from './CreateInternet';

export default {
    name: 'internet-active',
    components: {
        InternetTable,
        CreateInternet
    },
    data() {
        return {
            search: '',
            reload_table: 0,
            chosen_building: '',
            exportCSV: 0,
            filterStatus: null,
            statusOptions: [
                { text: "Tất cả", value: null },
                { text: "Mạng trống", value: 0 },
                { text: "Đang hoạt động", value: 1 },
                { text: "Trả phòng", value: 2 },
            ]
        };
    },
    mounted() {
        this.reload_table++
    },
};
</script>